import { render, staticRenderFns } from "./ProductSideSheet.vue?vue&type=template&id=de199a70&scoped=true"
import script from "./ProductSideSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSideSheet.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSideSheet.vue?vue&type=style&index=0&id=de199a70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de199a70",
  null
  
)

export default component.exports